import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';
import {Avatar, Box, Card, CardHeader, Divider, Link} from '@mui/material';
import ShortFiler from '../../../types/filers/shortFiler';


interface Props {
    filers: ShortFiler[];
}

const FilerList = (props:Props): JSX.Element => {

  const theme = useTheme();
  const [filerList, setFilerList] = useState<ShortFiler[]>([]);
  const [toggleViewMore, setToggleViewMore] = useState(false);

  useEffect(() => {
    setFilerList(props.filers.slice(0,3));
    setToggleViewMore(props.filers.length > 3? true: false);
  }, [props.filers]);

  const handleViewMore = () => {
    setToggleViewMore(!toggleViewMore);
    setFilerList(props.filers);
  }

  return (
    <Box>
        <Typography
            variant="h6"
            align={'left'}
            sx={{
            fontWeight: 700,
            }}
            color={'secondary'}
            paddingTop={3}
            gutterBottom
        >
        Filers
        </Typography>
        <Divider textAlign="right">
            <Typography component={'i'} variant='body2' color="primary">{props.filers.length} total result(s)</Typography>
        </Divider>
        <Grid container marginTop={3}>
          {filerList.map((filer) => (
            <Grid size={{xs:12, md:10}} key={filer.cpfId} marginBottom={2}>
              <Box
                width={1}
                height={1}
                className='is-clickable'
                onClick={() => window.location.assign(`/filers?q=${filer.cpfId}`)}
                component={Card}
                boxShadow={0}
                variant={'outlined'}
                bgcolor={'alternate.main'}
                sx={{
                    transition: 'all .2s ease-in-out',
                    '&:hover': {
                      transform: `translateY(-${theme.spacing(1 / 2)})`,
                    }
                  }}
                >
                <CardHeader
                    avatar={
                        filer.isCandidate &&
                        <Avatar
                        src={filer.filerThumbnailPhotoUrl}
                        variant={'circular'}
                        sx={{ width: 48, height: 48}}
                      />
                    }
                    action={
                        <Typography
                            variant={'caption'}
                            fontWeight={550}
                            sx={{
                            bgcolor: filer.isActive?alpha(theme.palette.success.light, 0.1): alpha(theme.palette.error.light, 0.1),
                            color: filer.isActive? theme.palette.success.dark: theme.palette.error.dark,
                            paddingX: 1.5,
                            paddingY: 0.5,
                            borderRadius: 4,
                            display: 'inline',
                            }}
                        >
                    {filer.isActive? 'Active': 'Inactive'}
                  </Typography>
                    }
                    title={`${filer.cpfId} ${filer.filerName}`}
                    titleTypographyProps ={{
                        variant: 'subtitle1',
                        fontWeight: 550,
                        color: filer.isActive? 'primary': 'error',
                      }}
                    subheader={filer.isCandidate && filer.officeDescription }
                    subheaderTypographyProps={{ 
                        variant: 'subtitle2',
                        component: 'i',
                    }}
                />
              </Box>
            </Grid>
          ))}
          {
            toggleViewMore && 
            <Grid size={10} display="flex" justifyContent="flex-end" marginTop={1}>
              <Link className='is-clickable' onClick={handleViewMore} underline='hover' fontSize={"small"}  component={"i"}><i>View More Results</i></Link>
            </Grid>
          }
        </Grid>
  </Box>
  );
};

export default FilerList;